export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-city/index.js